import { useEffect, useState } from "react";
import {
  fetchResourceTilesByTagFilters,
  type TaggedResourceTiles,
} from "../../../utils/contentful-helpers";

export const useTaggedResourceTiles = (tagFilters: string[]) => {
  const [taggedResourceTiles, setTaggedResourceTiles] = useState<
    TaggedResourceTiles[]
  >([]);

  useEffect(() => {
    let cancelled = false;

    const loadResourceTiles = async () => {
      try {
        const tiles = await fetchResourceTilesByTagFilters(tagFilters);

        if (!cancelled) {
          setTaggedResourceTiles(tiles);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch resource tiles:", error);
        }
      }
    };

    void loadResourceTiles();

    return () => {
      cancelled = true;
    };
  }, [tagFilters]);

  return taggedResourceTiles;
};
